export const isNonEmptyString = (value?: string | null): value is string =>
  typeof value === 'string' && value.trim().length > 0
